import React, { useEffect, useRef } from "react";

const text = `
<div>
    <ul>
        <li><a href="https://github.com" target="_blank">GitHub</a></li>
        <li><a href="https://google.com">Google</a></li>
    </ul>
</div>
`;
export default () => {
    const wrapper = useRef(null);

    const handleOnClick = (e) => {
        if (e?.target instanceof HTMLAnchorElement) {
            e.preventDefault();

            console.log(e.target.href, e.target.target);
        }
    };

    useEffect(() => {
        // wrapper.current.addEventListener("click", handleOnClick);
        // return () => {
        //     wrapper.current.removeEventListener("click", handleOnClick);
        // };
    }, []);

    return (
        <div>
            <div ref={wrapper} dangerouslySetInnerHTML={{ __html: text }} />
        </div>
    );
};
